import {
  UserLayout
  // TabLayout,
  // RouteView,
  // BlankLayout,
  // PageView
} from '@/components/layouts'

/**
 * 走菜单，走权限控制
 * @type {[null,null]}
 */
export const asyncRouterMap = []

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      }
    ]
  },
  {
    path: '/404',
    component: resolve => require([/* webpackChunkName: "fail" */ '@/views/exception/404'], resolve)
  },
  {
    path: '/403',
    component: resolve => require([/* webpackChunkName: "fail" */ '@/views/exception/403'], resolve)
  },
  {
    path: '/500',
    component: resolve => require([/* webpackChunkName: "fail" */ '@/views/exception/500'], resolve)
  },
  {
    path: '/503',
    component: resolve => require([/* webpackChunkName: "fail" */ '@/views/exception/503'], resolve)
  }
]
